import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { getCDNUrl } from "../../../commons/CommonFunctions";

class Autocomplete extends Component {
  static propTypes = {
    suggestions: PropTypes.instanceOf(Array),
  };

  static defaultProps = {
    suggestions: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      // The active selection's index
      activeSuggestion: 0,
      // The suggestions that match the user's input
      filteredSuggestions: [],
      // Whether or not the suggestion list is shown
      showSuggestions: false,
      // What the user has entered
      userInput: "",

      url: "",
    };
  }

  componentWillReceiveProps(props, state) {
    if (
      props.defaultValue != this.props.defaultValue &&
      this.state.userInput != props.defaultValue
    ) {
      this.setState({ userInput: props.defaultValue });
    }
    if(props.inputReset){
      this.setState({ userInput: '' });
    }
  }

  isFaculty = () => {
    return this.props.key == "faculty" || this.props.name == "faculty";
  };

  onChange = (e) => {
    const { suggestions } = this.props;
    let userInput = e.currentTarget.value;

    // Filter our suggestions that don't contain the user's input
    const filteredSuggestions = !(
      this.props.key == "faculty" || this.props.name == "faculty" ||this.props.key == "participant" || this.props.name == "participant" || this.props.name == "wpondNomination"
    )
      ? suggestions.filter(
          (suggestion) =>
            suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
        )
      : suggestions.filter(
          (suggestion) =>
            suggestion.value.toLowerCase().indexOf(userInput.toLowerCase()) > -1
        );
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions,
      showSuggestions: true,
      userInput: e.currentTarget.value,
    });
  };

  onClick = (e, url, id,userType, address) => {
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: e.currentTarget.innerText,
    });

    if (this.props.onChange) {
      let selectedText = e.currentTarget.innerText;
      if (this.props.key == "faculty" || this.props.name == "faculty" || this.props.key == "participant" || this.props.name == "participant") {
        this.props.onChange(this.props.name, selectedText, url, id,userType);
        this.setState({ userInput: "" });
      } else if(this.props.name == "wpondNomination") {
        this.props.onChange(this.props.name, selectedText, url, id, address);
      } else {
        this.props.onChange(this.props.name, selectedText);
      }
    }
  };

  onKeyDown = (e) => {
    const { activeSuggestion, filteredSuggestions } = this.state;

    if (e.keyCode === 13) {
      e.preventDefault();
     /* this.setState({
        activeSuggestion: 0,
        showSuggestions: false,
        userInput: filteredSuggestions[activeSuggestion].value,
      },()=>{
        if (this.props.onChange) {
          let selectedText = filteredSuggestions[activeSuggestion].value;
          if (this.props.key == "faculty" || this.props.name == "faculty" || this.props.key == "participant" || this.props.name == "participant") {
            this.props.onChange(this.props.name, selectedText, filteredSuggestions[activeSuggestion].img, filteredSuggestions[activeSuggestion].id);
            this.setState({ userInput: "" });
          } else {
            this.props.onChange(this.props.name, selectedText);
          }
        }
      });*/

    }
    // User pressed the up arrow
    else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion - 1 });
    }
    // User pressed the down arrow
    else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }

      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };

  render() {
    const {
      onChange,
      onClick,
      onKeyDown,
      state: {
        activeSuggestion,
        filteredSuggestions,
        showSuggestions,
        userInput,
      },
    } = this;

    let suggestionsListComponent;

    if (showSuggestions && userInput) {
      if (filteredSuggestions.length) {
        let style = {};
        if (this.props.key == "faculty" || this.props.name == "faculty" || this.props.key == "participant" || this.props.name == "participant" || this.props.name == "wpondNomination") {
          suggestionsListComponent = (
            <ul className="suggestions">
              {filteredSuggestions.map((suggestion, index) => {
                let className;

                // Flag the active suggestion with a class
                if (index === activeSuggestion) {
                  className = "suggestion-active";
                }

                return (
                  <li
                    id={suggestion.id}
                    className={className}
                    style={{ textAlign: "left" }}
                    key={index}
                    onClick={(e) => {
                      onClick(e, suggestion.img, suggestion.id,suggestion.type);
                    }}
                  >
                    <div className={"username" + (suggestion.type === "COMPANY" ? " orgnzName" : "")}>
                      {" "}
                      <figure className= {"user"}>
                        <img
                          src={getCDNUrl(suggestion.img)}                          
                          alt=""
                        />
                      </figure>
                      <span>{suggestion.value}</span>
                    </div>
                  </li>
                );
              })}
            </ul>
          );
        } else {
          suggestionsListComponent = (
            <ul className="suggestions">
              {filteredSuggestions.map((suggestion, index) => {
                let className;

                // Flag the active suggestion with a class
                if (index === activeSuggestion) {
                  className = "suggestion-active";
                }

                return (
                  <li
                    className={className}
                    key={suggestion}
                    onClick={(e) => onClick(e, undefined)}
                  >
                    {suggestion}
                  </li>
                );
              })}
            </ul>
          );
        }
      } else {
        suggestionsListComponent = (
          <div className="no-suggestions">
            {/* <em>No suggestions, you're on your own!</em> */}
          </div>
        );
      }
    }

    if (this.props.key == "faculty" || this.props.name == "faculty" || this.props.key == "participant" || this.props.name == "participant") {
      return (
        <Fragment>
          {React.cloneElement(this.props.children, {
            onChange: onChange,
            onKeyDown: onKeyDown,
            value: userInput,
          })}
         {suggestionsListComponent}
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          {React.cloneElement(this.props.children, {
            onChange: onChange,
            onKeyDown: onKeyDown,
            value: userInput,
          })}
          {suggestionsListComponent}
        </Fragment>
      );
    }
  }
}

export default Autocomplete;
